module.exports = __webpack_public_path__ + "static/email-template-account-activation-96be37eadb828b055c3f0b65302499b3.jpg";